// 物料入库管理
import {contractApi} from "@/axios";
//获取入库信息
export function getStockPage(params,sendData){
    return contractApi({
        url:'/material-stock-in/page',
        method:'post',
        data:sendData,
        params:params
    })
}
//删除入库信息
export function deleteStock(params){
    return contractApi({
        url:'/material-stock-in',
        method:'delete',
        params:params
    })
}
//添加入库信息
export function addStock(data){
    return contractApi({
        url:'/material-stock-in',
        method:'post',
        data:data
    })
}
//修改入库信息
export function editStock(data){
    return contractApi({
        url:'/material-stock-in',
        method:'put',
        data:data
    })
}
